import axios from 'axios'
export default {
	data: () => ({
		loading: false,
	}),

	props: {
		value: 			{ type: Object, default: () => {} },
		defaultIndex:  		{ type: Number, default: -1},
		//default:  		{ type: [Number, Object], default: null},
		label:  		{ type: String, default: 'Тип'},
		placeholder:  	{ type: String, default: null},
		hint:  			{ type: String, default: null},
		persistentHint:	{ type: Boolean, default: false },
		readonly:		{ type: Boolean, default: false },
		clearable:		{ type: Boolean, default: false },
		outlined: 		{ type: Boolean, default: false },
		dense: 			{ type: Boolean, default: false },
		//prependIcon:  	{ type: String, default: null}, //"mdi-calendar
		hideDetails: 	{ type: [Boolean, String], default: 'auto' },
		rules:			{ type: Array, default: () => [] },
	},

	computed: {
		model: {
			get() 		{ return this.value },
			set(val) 	{ this.$emit('input', val) }
		},

		/* rules() {
			return {
				required: (value) => !!value || "Заповнити обов'язково",
				mustBeSelected: (value) => typeof(value) === "undefined" || value === null || value?.id>0 || this.$vuetify.locale.t('$vuetify.rule.mustBeSelected'),
				
				code: (value) => {
					const pattern = /^([a-zA-Z'\-]+)/
					return (value === null || value.length == 0 || value.length > 32 || pattern.test(value)) || this.$vuetify.locale.t('$vuetify.rule.code', [128])
				},
				name: (value) => {
					const pattern = /^([a-zA-Zа-яА-ЯЇї'\-]+)/
					return (value && value.length <= 10 && pattern.test(value)) || 'Name is not correct'
					//return value === null || ( value.length <= 10 && pattern.test(value)) || 'Name is not correct'
				},
				date: (value) => {
					//console.log('form.mixin', 'rules.date', 'value', value)
					return (value === null || value?.length == 0 || moment(value, "DD.MM.YYYY", true).isValid() || moment(value, "YYYY-MM-DD", true).isValid()) || 'Date is not correct'
				},

				datetime: (value) => {
					return (value === null || value.length == 0 || moment(value, "YYYY-MM-DDTHH:mm", true).isValid()) || 'Date is not correct'
				},

				email: (value) => {
					const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
					return pattern.test(value) || this.$vuetify.locale.t('$vuetify.rule.email')//'Некоректний e-mail.'
				},
				phone: (value) => {
					const pattern = /^\+?3?8?(0\d{9})$/
					//return (value === null || value?.length == 0 || pattern.test(value)) || 'Номер телефону не вірний (+380961112233)'
					return pattern.test(value) || 'Номер телефону не вірний (+380961112233)'
				},
				personsname: (value) => {
					const pattern = /^([a-zA-Zа-яА-ЯЇї'\- ]+)/
					return (value && value.length <= 10 && pattern.test(value)) || this.$vuetify.locale.t('$vuetify.rule.personsname')//'Name is not correct'
				},
			}
		}, */
	},

	created () {
		this.onLoad();
	},
	
	methods: {

		setItems() { },

		setDefault() { 
			if(this.defaultIndex >= 0 && this.defaultIndex < this.items.length) {
				//console.log('combobox:mixin', 'onLoad', 'defaultIndex', this.defaultIndex)
				this.model = this.items[this.defaultIndex]
			}
		},

		onClear() {
			this.setItems()
			this.model = null
		},

		onLoad() {
			this.loading = true;
			this.load().then(() => {
				//console.log('combobox:mixin', 'onLoad', 'defaultIndex', this.defaultIndex)
				this.setDefault();
			}).finally(() => (this.loading = false));
		},

		onRefresh(item) {
			if(item) {
				this.onLoad()
			} else {
				this.onClear()
			} 
		},
	},
}